import { useRecoilValue } from 'recoil'
import sandboxAtom from '../../sandbox.atom'
import { useCallback, useState } from 'react'
import { ITextOption } from '../../sandbox.types'
import { IDraftImage, ITask } from '../../../../types/tasks.types'

const useSandboxTask = (onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void) => {
  const { draftTask } = useRecoilValue(sandboxAtom)
  const [createOptionModalOpen, setCreateOptionModalOpen] = useState(false)

  const handleImage = useCallback(
    (image: File) => {
      if (image) onDraftTaskChange([{ imageFile: image, rightAnswer: false }], 'images')
    },
    [onDraftTaskChange]
  )

  const handleImageScaleChange = (scale: number) => {
    onDraftTaskChange([{ ...draftTask.images[0], scale } as IDraftImage], 'images')
  }

  const toggleCreateOptionModal = () => setCreateOptionModalOpen((prev) => !prev)

  const handleOptionDelete = (index: number) => {
    onDraftTaskChange(
      [...draftTask.answerOptions.slice(0, index), ...draftTask.answerOptions.slice(index + 1)],
      'answerOptions'
    )
  }

  const handleOptionChange = (index: number, changed: ITextOption) => {
    onDraftTaskChange(
      [...draftTask.answerOptions.slice(0, index), changed, ...draftTask.answerOptions.slice(index + 1)],
      'answerOptions'
    )
  }

  const handleOptionCreate = (option: ITextOption) => {
    setCreateOptionModalOpen(false)
    onDraftTaskChange([...draftTask.answerOptions, option], 'answerOptions')
  }

  return {
    draftTask,
    createOptionModalOpen,
    toggleCreateOptionModal,
    handleOptionCreate,
    handleOptionDelete,
    handleImageScaleChange,
    handleOptionChange,
    handleImage,
  }
}

export default useSandboxTask
